import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {StatoEnum} from '../../../_models/generated/stato-enum';
import {STATO_ENUM_UI} from '../../../_helpers/StatoEnum';
import {mascheraDaStati, STATI_SCRITTURA_SELEZIONABILI, statiDaMaschera} from '../../../_helpers/stati-scrittura';

/**
 * Feature 155: selezione multipla degli stati d'ordine che il WriteService scrive sulla macchina.
 * Lavora sulla maschera di bit di `Risorsa.statiScrittura`; `null` mostra il default, nessuna voce = `0`.
 */
@Component({
  selector: 'app-stati-scrittura-input',
  templateUrl: './stati-scrittura-input.component.html',
  standalone: false
})
export class StatiScritturaInputComponent implements OnChanges {
  @Input() statiScrittura: number | null | undefined;
  @Output() statiScritturaChange = new EventEmitter<number>();

  readonly opzioni = STATI_SCRITTURA_SELEZIONABILI.map(stato => ({stato, label: STATO_ENUM_UI[stato].label}));

  // Array stabile tra un rilevamento e l'altro: un getter ne creerebbe uno nuovo a ogni ciclo per [value].
  selezionati: StatoEnum[] = statiDaMaschera(null);

  get nessuno(): boolean {
    return this.selezionati.length === 0;
  }

  ngOnChanges() {
    this.selezionati = statiDaMaschera(this.statiScrittura);
  }

  onChange(stati: StatoEnum[] | null) {
    this.statiScrittura = mascheraDaStati(stati);
    this.selezionati = statiDaMaschera(this.statiScrittura);
    this.statiScritturaChange.emit(this.statiScrittura);
  }
}
